import { useUserState } from '@/state/user.state';
import { useAuthStore } from '@/state/auth.state';
import { useMutation } from '@tanstack/react-query';
import { authControllerCheck } from '@/api-client/api';
import consola from 'consola';
import { useCallback } from 'react';
import { queryClient } from '@/api-client/query-client';
import { useNavigate } from 'react-router';
import { useSocketsContext } from '@/shared/libs/sockets/sockets.context';

export function useLogout() {
    const navigate = useNavigate();
    const setRole = useUserState((state) => state.setRole);
    const setIsAuthenticated = useAuthStore((state) => state.setIsAuthenticated);

    return useCallback(() => {
        setIsAuthenticated(false);
        setRole(null);
        queryClient.clear();

        if (![ '/sign-in', '/tg-auth' ].includes(location.pathname)) {
            const back =
                location.pathname !== '/'
                    ? location.pathname + location.search
                    : null;
            if (back) {
                localStorage.setItem('back', back);
            }
            navigate(`/sign-in${back ? `?back=${ back }` : ''}`);
        }
    }, [navigate, setIsAuthenticated, setRole]);
}

export function useCheckAuth() {
    const logout = useLogout();
    const { connect } = useSocketsContext();
    const setRole = useUserState((state) => state.setRole);
    const setUserId = useUserState((state) => state.setUserId);
    const setIsAuthenticated = useAuthStore((state) => state.setIsAuthenticated);
    const setIsLoading = useAuthStore((state) => state.setIsLoading);

    const { mutate } = useMutation({
        mutationFn: () => {
            setIsLoading(true);
            return authControllerCheck();
        },
        onSuccess(response) {
            setIsAuthenticated(true);
            setRole(response.role);
            setUserId(response.id);
            connect(response.id);
        },
        onError(err) {
            consola.error(err);
            logout();
        },
        onSettled() {
            setIsLoading(false);
        },
    });
    
    return {
        checkAuth: mutate,
    }
}